var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15.999,
    viewBox: "0 0 20 15.999",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messages",
    d: "M6.334,9H11a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H2A1,1,0,0,0,1,2V8A1,1,0,0,0,2,9H3a1,1,0,0,1,1,1v.5L5.734,9.2A.99.99,0,0,1,6.334,9ZM11,10H6.334L3.8,11.9a.5.5,0,0,1-.525.047A.492.492,0,0,1,3,11.5V10H2A2,2,0,0,1,0,8V2A2,2,0,0,1,2,0h9a2,2,0,0,1,2,2V8A2,2,0,0,1,11,10Zm-1,4a2,2,0,0,1-2-2V11H9v1a1,1,0,0,0,1,1h3.666a.99.99,0,0,1,.6.2L16,14.5V14a1,1,0,0,1,1-1h1a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H14V4h4a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H17v1.5a.5.5,0,0,1-.275.447A.506.506,0,0,1,16.2,15.9L13.666,14Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/messages.27568937e8c55f5ab5d2cc8dfa9b2d9f.svg";